<template>
  <div class="course_introduce">
    <div class="course_introduce_content" ref="content" :class="{ expanded: isExpanded }">
      <div class="evaluate_info mar_top_20">
        <div class="flex Flexalign discuss_text">
          <div>问答</div>
          <div class="mar_left_10">{{ listTotal }}</div>
        </div>
        <div class="flex Flexalign question_box mar_top_20">
          <el-image class="avatar" :src="userInfo.headImage"></el-image>
          <div class="question_content flex flexcolumn mar_left_10 flex-1">
            <el-input v-model="questionInfo.content" style="width: 100%; min-height: 80px" autosize type="textarea"
              placeholder="你可以向大家提问，或者分享学习心得，发布讨论可获得5积分。" />
            <div class="flex Flexalign FlexBetween upload_box">
              <el-upload v-model:file-list="imgList" :action="uploadUrl" list-type="picture-card"
                :on-remove="handleRemove" :before-upload="handleChange">
                <el-image class="img_upload_icon" :src="iconPath('img_upload_icon.png')"></el-image>
              </el-upload>
              <div class="commit_btn cursor_pointer" :class="[questionInfo.content ? 'active_commit_btn' : '']"
                @click="commitDiscuss">
                发布
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="evaluate_list" v-if="listTotal">
        <div class="evaluate_one flex" v-for="(item, index) in evaluateList" :key="index">
          <div class="flex" style="width: 100%;"
            v-if="item.auditStatus == 2 || userInfo.buyerUserId == item.buyerUserId">
            <div class="evaluate_one_left">
              <el-image class="avatar" :src="imgPath(item.buyerUserHeadImage)"></el-image>
            </div>
            <div class="evaluate_one_right flex-1">
              <div class="flex Flexalign evaluate_name">
                <div>{{ item.buyerUserName }}</div>
                <!-- <div class="evaluate_rate">
                <el-image class="member_logo" :src="iconPath('member_logo.png')"></el-image>
              </div> -->
              </div>
              <div class="evaluate_content flex FlexBaseline">
                <el-image class="question_icon" :src="iconPath('question_icon.png')"></el-image>
                <!-- {{ item.content.split("url:")[0] }} -->
                <div class="flex-1" v-html="getContent(item.content)"></div>
              </div>
              <div class="question_img flex Flexalign" v-if="item.questionImg">
                <el-image class="questionImg mr-15 mt-15" v-for="(img, imgIndex) in item.questionImg"
                  :src="imgPath(img)" :key="imgIndex" :preview-src-list="[img]"></el-image>
              </div>
              <div class="evaluate_time flex Flexalign FlexBetween">
                <div>
                  {{ item.createTime
                  }}{{
                    item.auditStatus == 1
                      ? "·内容审核中 仅自己可见"
                      : (item.auditStatus == 3
                        ? "审核不通过"
                        : "")
                  }}
                </div>
                <div class="reply_box flex Flexalign">
                  <div class="flex Flexalign cursor_pointer" @click="addReply(item.discussId, 2)">
                    <el-image class="reply_img" :src="imgPath('reply_icon.png')"></el-image>
                    <div class="reply_text">回复</div>
                  </div>
                  <div class="split_line"></div>
                  <el-image class="reply_img cursor_pointer" :src="imgPath('like_icon.png')" v-show="!item.isLiked"
                    @click="evaluateLike(item.discussId, index)"></el-image>
                  <el-image class="reply_img cursor_pointer" :src="imgPath('liked_icon.png')" v-show="item.isLiked"
                    @click="evaluateLike(item.discussId, index)"></el-image>
                  <div class="reply_text">{{ item.likeNum }}</div>
                </div>
              </div>
              <div class="" v-if="item.subEvaluateList.length">
                <div class="subEvaluate_box" :class="{ expanded: isExpanded }" ref="subEvaluate">
                  <div class="subEvaluate_one" v-for="(sitem, sindex) in item.subEvaluateList" :key="sindex">
                    <div class="flex Flexalign evaluate_name reply_info" v-if="sitem.businessUserId">
                      <el-image class="avatar" :src="imgPath(sitem.businessUserAvatar)"></el-image>
                      <div class="replyer_name">{{ sitem.businessUserName }}</div>
                      <!-- <el-image class="omment_icon" :src="iconPath('omment_icon.png')"
                        v-if="sitem.isComment"></el-image> -->
                      <div class="replyer_tag">老师</div>
                      <div class="reply_text">回复</div>
                      <div class="replyer_name">{{ sitem.targetBuyerUserName }}:</div>
                    </div>
                    <div class="flex Flexalign evaluate_name reply_info" v-else>
                      <el-image class="avatar" :src="imgPath(sitem.buyerUserHeadImage)"></el-image>
                      <div class="replyer_name">{{ sitem.buyerUserName }}</div>
                      <el-image class="omment_icon" :src="iconPath('omment_icon.png')"
                        v-if="sitem.isComment"></el-image>
                      <div class="reply_text">回复</div>
                      <div class="replyer_name">{{ sitem.targetBuyerUserName }}:</div>
                    </div>
                    <div class="evaluate_content reply_evaluate_content">
                      {{ sitem.content }}
                    </div>
                    <div class="evaluate_time reply_evaluate_time flex Flexalign FlexBetween">
                      <div>{{ sitem.createTime }}</div>
                      <div class="reply_box flex Flexalign">
                        <el-image class="reply_img" :src="imgPath('reply_icon.png')"></el-image>
                        <div class="reply_text cursor_pointer" @click="addReply(sitem.replyId, 3)">
                          回复
                        </div>
                        <div class="split_line"></div>
                        <el-image class="reply_img cursor_pointer" :src="imgPath('like_icon.png')" v-if="!sitem.isLiked"
                          @click="evaluateReplyLike(sitem.replyId, index, sindex)"></el-image>
                        <el-image class="reply_img cursor_pointer" :src="imgPath('liked_icon.png')"
                          @click="evaluateReplyLike(sitem.replyId, index, sindex)" v-else></el-image>
                        <div class="reply_text">{{ sitem.likeNum }}</div>
                      </div>
                    </div>
                  </div>
                  <div v-if="groupPageSize <= item.subEvaluateList?.length">
                    <div class="mar_top_10 flex Flexalign cursor_pointer" @click="getMoreSubEvaluate(item)" v-if="
                      item.subEvaluateList[0].totalNum != item.subEvaluateList?.length
                    ">
                      查看剩余回复
                      <el-icon>
                        <ArrowDown />
                      </el-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="pagination_box mar_top_10 flex FlexjustifyEnd" v-if="isExpanded && listTotal > listQuery.pageSize"> -->
        <div class="pagination_box mar_top_10 flex FlexjustifyEnd" v-if="listTotal > listQuery.pageSize">
          <el-pagination background layout="prev, pager, next" :total="listTotal"
            @current-change="handleCurrentChange" />
        </div>
      </div>
      <div v-else>
        <moe-empty url="moe_empty_bg_img.png" emptyText="暂无问答"></moe-empty>
      </div>
    </div>
    <!-- <div class="more_load flex Flexalign Flexjustify cursor_pointer" v-if="showLoadMore && listTotal"
      @click="toggleExpand">
      {{ isExpanded ? "收起" : "加载更多" }}
      <el-icon v-if="!isExpanded">
        <ArrowDown />
      </el-icon>
      <el-icon v-else>
        <ArrowUp />
      </el-icon>
    </div> -->
    <evaluateReply ref="evaluateReply" @refreshGetList="getDiscussList"></evaluateReply>
  </div>
</template>

<script>
import evaluateReply from "@/components/popup/evaluateReply.vue";
import * as config from "@/config/config";
import { mapState } from "vuex";
export default {
  name: "GjkcH5Discuss",
  components: {
    evaluateReply,
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
      selectLearningInfo: (state) => state.learning.selectLearningInfo,
    }),
  },
  props: {
    courseId: {},
  },
  watch: {
    courseId: {
      handler() {
        if (this.courseId) {
          this.listQuery.courseId = this.courseId;
          this.questionInfo.courseId = this.courseId;
          this.getDiscussList();
        }
      },
      deep: true,
    },
    selectLearningInfo: {
      handler() {
        // 仅课堂下的问答传此参数
        this.questionInfo.chapterId = this.selectLearningInfo.chapterId;
        this.questionInfo.schemeChapterPhaseId = this.selectLearningInfo.id;
        // 仅课堂下的问答传此参数
        this.listQuery.chapterId = this.selectLearningInfo.chapterId;
        this.listQuery.schemeChapterPhaseId = this.selectLearningInfo.id;
        this.listQuery.courseId = this.courseId;
        this.questionInfo.courseId = this.courseId;
        this.getDiscussList();
      }
    }
  },

  data() {
    return {
      isExpanded: false,
      showLoadMore: false,
      evaluateList: [],
      questionInfo: {
        classify: 2, //1=老师答疑区，2=课堂交流区，3=综合讨论区
        content: "",
        courseId: "",
        imgs: [],
        chapterId: '',  // 仅课堂下的问答传此参数
        schemeChapterPhaseId: '',   // 仅课堂下的问答传此参数
      },
      listQuery: {
        page: 1,
        pageSize: 10,
        courseId: "",
        classify: 2, //1=老师答疑区，2=课堂交流区，3=综合讨论区
        chapterId: '',  // 仅课堂下的问答传此参数
        schemeChapterPhaseId: '',   // 仅课堂下的问答传此参数
      },
      listTotal: "",
      groupPageSize: 3,
      uploadUrl: "",
      imgList: [],
    };
  },

  // watch: {
  //   items: {
  //     immediate: true,
  //     handler() {
  //       this.$nextTick(this.checkOverflow);
  //     },
  //   },
  // },

  mounted() {
    this.uploadUrl = config.COMMON_UPLOAD_URL;
    // this.checkOverflow();
    // 仅课堂下的问答传此参数
    this.questionInfo.chapterId = this.selectLearningInfo.chapterId;
    this.questionInfo.schemeChapterPhaseId = this.selectLearningInfo.id;
    // 仅课堂下的问答传此参数
    this.listQuery.chapterId = this.selectLearningInfo.chapterId;
    this.listQuery.schemeChapterPhaseId = this.selectLearningInfo.id;
    if (this.courseId) {
      this.listQuery.courseId = this.courseId;
      this.questionInfo.courseId = this.courseId;
      this.getDiscussList();
    }
  },

  methods: {
    getContent(content) {
      // 判断是否富文本
      const regex = /<(p|div|span|b|i|u|strong|em|img|ul|li|br)\b[^>]*>/i;
      let flag = regex.test(content);
      if (flag) {
        return content
      } else {
        return content.split("url:")[0]
      }
    },
    handleCurrentChange(value) {
      this.listQuery.page = value;
      this.getDiscussList();
    },
    checkOverflow() {
      if (!this.$refs.content) return;
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    // 上传图片
    handleChange(uploadFile, uploadFiles) {
      console.log(uploadFile.url, uploadFiles);
      // this.$Api.common
      //   .uploadFile(uploadFile.url)
      //   .then((res) => {
      //     console.log(res);
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    handleRemove(uploadFile, uploadFiles) {
      console.log(uploadFile, uploadFiles);
    },
    // 获取答疑区列表
    getDiscussList() {
      this.$Api.course
        .getDiscussList(this.listQuery)
        .then((res) => {
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          let list = res.data.data.list;
          // 没有数据不在请求接口了
          if (!res.data.data.list?.length) return
          for (const item of list) {
            // item.score = this.$Tools.scoreToStar(item.score);
            item.isLiked = false;
            item.isFirstLoad = true; // 用于判断加载回复接口（为true则将初始的subEvaluateList置空，采用分页的接口获取数据填充，每点击一次页码+1）
            item.pageSize = 10; // 用于查询回复接口（分页）
            item.page = 1;
            item.subEvaluateList = [];
            // 修改了逻辑，之前在视频下发表主题是通过拼接的方式实现图文，现换成imgs和content，此处处理是为了兼容之前发布的主题
            if (this.$Tools.empty(item.imgs)) {
              let questionImg = item.content.split("url:");
              if (questionImg.length > 1) {
                item.questionImg = questionImg[1].split(";");
                let length = item?.questionImg.length;
                if (item.questionImg[length - 1] == "") {
                  item.questionImg.pop();
                }
              }
            } else {
              item.questionImg = item.imgs.split(",");
            }
          }
          this.evaluateList = list;
          this.listTotal = res.data.data.total ? Number(res.data.data.total) : 0;
          this.checkIsLike(); // 评价是否点赞
          this.getReplyListBySize(); // 获取评价下的回复
          this.checkReplyIsLike(); // 回复是否点赞
          setTimeout(() => {
            this.checkOverflow();
          }, 500);
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 获取回复信息
    async getReplyListBySize() {
      // try {
      //   const res = await this.$Api.course.getReplyListBySize(params);
      //   return res.data.data; // 直接返回解析后的数据
      // } catch (error) {
      //   console.error(error);
      //   return []; // 错误时返回空数组
      // }
      let listQuery = {
        courseId: this.courseId,
        scene: 2,
        sceneIds: "",
        groupPageSize: this.groupPageSize,
      };
      // 参数合集，查所有评价列表的回复
      this.evaluateList.forEach((item) => {
        listQuery.sceneIds += item.discussId + ",";
      });
      this.$Api.course
        .getReplyListBySize(listQuery)
        .then((res) => {
          // 遍历出对应评价的回复
          res.data.data.forEach((item) => {
            let findIndex = this.evaluateList.findIndex(
              (sitem) => sitem.discussId == item.sceneId
            );
            if (findIndex != -1) {
              this.evaluateList[findIndex].subEvaluateList.push(item);
            }
          });
        })
        .catch(() => { });
    },
    // 评价点赞
    evaluateLike(id, index) {
      let query = {
        courseId: this.courseId,
        scene: 2, // 1=评价 2=讨论组 3=回复
        sceneId: id, //评价ID、讨论组主题ID、回复ID
      };
      this.$Api.course
        .evaluateLike(query)
        .then((res) => {
          console.log(res);
          if (this.evaluateList[index].isLiked) {
            this.evaluateList[index].likeNum--;
          } else {
            this.evaluateList[index].likeNum++;
          }
          this.evaluateList[index].isLiked = !this.evaluateList[index].isLiked;
          // this.evaluateList = [];
          // this.getEvaluateList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 评价回复点赞
    evaluateReplyLike(id, index, sindex) {
      let query = {
        courseId: this.courseId,
        scene: 3, // 1=评价 2=讨论组 3=回复
        sceneId: id, //评价ID、讨论组主题ID、回复ID
      };
      this.$Api.course
        .evaluateLike(query)
        .then((res) => {
          console.log(res);
          if (this.evaluateList[index].subEvaluateList[sindex].isLiked) {
            this.evaluateList[index].subEvaluateList[sindex].likeNum--;
          } else {
            this.evaluateList[index].subEvaluateList[sindex].likeNum++;
          }
          this.evaluateList[index].subEvaluateList[sindex].isLiked = !this.evaluateList[
            index
          ].subEvaluateList[sindex].isLiked;
          // this.evaluateList = [];
          // this.getEvaluateList();
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 判断是否点赞（评价）
    checkIsLike() {
      let listQuery = {
        courseId: this.courseId,
        scene: 2,
        sceneIds: "",
      };
      this.evaluateList.forEach((item) => {
        listQuery.sceneIds += item.discussId + ",";
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course
        .checkIsLike(listQuery)
        .then((res) => {
          this.evaluateList.forEach((item) => {
            let currentIndex = res.data.data.findIndex(
              (sitem) => sitem == item.discussId
            );
            if (currentIndex != -1) item.isLiked = true;
          });
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 判断是否点赞（评价回复）
    checkReplyIsLike() {
      let listQuery = {
        courseId: this.courseId,
        scene: 3,
        sceneIds: "",
      };
      this.evaluateList.forEach((item) => {
        item.subEvaluateList.forEach((sitem) => {
          listQuery.sceneIds += sitem.replyId + ",";
        });
      });
      if (!listQuery.sceneIds) return;
      this.$Api.course.checkIsLike(listQuery).then((res) => {
        this.evaluateList.forEach((item) => {
          item.subEvaluateList.forEach((sitem) => {
            let currentIndex = res.data.data.findIndex(
              (ssitem) => ssitem == sitem.replyId
            );
            if (currentIndex != -1) sitem.isLiked = true;
          });
        });
      });
    },
    getMoreSubEvaluate(info) {
      if (!info.isFirstLoad) {
        ++info.page;
      }
      let listQuery = {
        page: info.page,
        pageSize: info.pageSize,
        courseId: this.courseId,
        scene: 2, // 场景：1评价，2讨论组
        sceneId: info.discussId,
        lteCreateTime: info.subEvaluateList[0].createTime,
      };
      this.$Api.course
        .getReplyList(listQuery)
        .then((res) => {
          // 第一次查询回复列表限制了条数，后面每次点击查询更多调用分页接口查询
          if (info.isFirstLoad) {
            info.subEvaluateList = res.data.data.list;
            info.isFirstLoad = false;
          } else {
            info.subEvaluateList = [...info.subEvaluateList, ...res.data.data.list];
          }
          // 加个字段用于判断当前回复数是否已加载完（用于是否展示加载剩余回复字样）
          info.subEvaluateList.forEach((item) => {
            item.totalNum = res.data.data.total;
          });
          this.checkReplyIsLike(); // 回复是否点赞
        })
        .catch((err) => {
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
    // 回复评价
    addReply(sceneId, scene) {
      this.$refs.evaluateReply.learningEvaluateShow = true;
      this.$refs.evaluateReply.evaluateInfo.sceneId = sceneId;
      this.$refs.evaluateReply.evaluateInfo.scene = scene;
    },
    // 发布讨论
    commitDiscuss() {
      if (!this.questionInfo.content) {
        this.$Dialog.toast("请输入提问内容", { type: "warning" });
        return;
      }
      // 修改了逻辑，之前在视频下发表主题是通过拼接的方式实现图文，现换成imgs和content，此处处理已弃用
      // let content = "";
      // content = this.questionInfo.content + "url:";
      // if (this.questionInfo.imgList.length) {
      //   this.questionInfo.imgList.forEach((item) => {
      //     content += item.response?.data?.url + ";";
      //   });
      // }
      // let questionInfo = {
      //   content: content,
      //   classify: this.questionInfo.classify,
      //   courseId: this.questionInfo.courseId,
      // };
      let questionImgs = [];
      if (this.imgList.length) {
        this.imgList.forEach((item) => {
          questionImgs.push(item.response?.data?.url)
        });
      }
      this.questionInfo.imgs = questionImgs.join(',');
      this.$Api.course
        .addDiscuss(this.questionInfo)
        .then(() => {
          this.$Dialog.toast("发布成功");
          this.questionInfo.content = "";
          this.questionInfo.imgs = [];
          this.imgList = [];
          this.getDiscussList();
        })
        .catch((err) => {
          this.questionInfo.content = "";
          this.questionInfo.imgs = [];
          this.imgList = [];
          // this.$Dialog.toast(err.message, { type: "error" });
          console.log(err);
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.course_introduce {
  // max-height: 550px;
  // overflow: hidden;
  position: relative;

  .course_introduce_content {
    // max-height: 550px;
    // overflow: hidden;

    .evaluate_info {
      margin-bottom: 20px;
      border-bottom: 1px solid rgba(20, 20, 20, 0.1);

      .discuss_text {
        // font-weight: bold;
        font-size: 20px;
        color: #333333;
      }

      .question_box {
        margin-bottom: 20px;

        .avatar {
          width: 34px;
          height: 34px;
          border-radius: 50%;
        }

        .question_content {
          // width: 100%;
          min-height: 117px;
          background: #f7f7f7;
          border-radius: 10px;
          position: relative;
          padding: 10px 0;

          :deep(.el-textarea__inner) {
            background: #f7f7f7;
            box-shadow: none;
            resize: none;
          }

          .upload_box {
            width: 100%;
            padding: 0 20px;
            box-sizing: border-box;

            // position: absolute;
            // bottom: 10px;
            :deep(.el-upload--picture-card) {
              width: auto;
              height: auto;
              border: none;
            }

            .img_upload_icon {
              width: 24px;
              height: 24px;
            }

            .commit_btn {
              width: 64px;
              height: 32px;
              background: #c2c2c2;
              border-radius: 16px;
              color: #ffffff;
              line-height: 32px;
              text-align: center;
            }

            .active_commit_btn {
              background: linear-gradient(90deg, #00d5c2, #00d498);
            }
          }
        }
      }
    }

    .evaluate_list {
      width: 100%;
      overflow: hidden;

      .evaluate_one {
        margin-top: 10px;

        .evaluate_one_left {
          .avatar {
            width: 48px;
            height: 48px;
            border-radius: 50%;
          }
        }

        .evaluate_one_right {
          margin-left: 13px;
          color: rgba(153, 153, 153, 1);

          .evaluate_rate {
            .member_logo {
              width: 72px;
              height: 28px;
            }

            // width: 72px;
            // height: 28px;
            // background: linear-gradient(90deg, #DEB879, #F3DFB7);
            // border-radius: 6px;
            margin-left: 13px;
          }

          .evaluate_content {
            margin-top: 5px;
            // font-weight: 600;
            color: #333333;

            .question_icon {
              margin-right: 7px;
              width: 26px;
              height: 17px;
            }
          }

          .question_img {
            // margin-top: 15px;
            margin-left: 30px;
            flex-wrap: wrap;

            .questionImg {
              width: 130px;
              height: 130px;
              border-radius: 10px;
              // width: 241px;
              // height: 148px;
            }
          }

          .evaluate_time {
            width: 100%;
            color: #999999;
            margin-top: 15px;

            .reply_box {
              .reply_img {
                width: 24px;
                height: 24px;
              }

              .split_line {
                margin: 0 12px;
                width: 1px;
                height: 20px;
                background: #141414;
                opacity: 0.1;
              }

              .reply_text {
                margin-left: 6px;
              }
            }
          }

          .subEvaluate_box {
            // max-height: 200px;
            overflow: hidden;
          }

          .expanded {
            max-height: none;
            overflow: visible;
          }

          .reply_info {
            margin-top: 10px;

            .avatar {
              width: 24px;
              height: 24px;
              border-radius: 50%;
            }

            .replyer_name {
              margin-left: 8px;
            }

            .replyer_tag {
              width: 32px;
              margin-left: 5px;
              height: 16px;
              background: #13D6AA;
              border-radius: 4px;
              font-size: 10px;
              color: #ffffff;
              line-height: 16px;
              text-align: center;
            }

            .omment_icon {
              margin-left: 8px;
              width: 46px;
              height: 17px;
            }

            .reply_text {
              margin-left: 10px;
              color: #333333;
              // font-weight: 600;
            }
          }

          .reply_evaluate_content {
            margin-top: 10px;
          }

          .reply_evaluate_time {
            margin-top: 10px;
          }
        }
      }
    }
  }

  .course_introduce_content.expanded {
    max-height: none;
    overflow: visible;
    /* 展开后高度 */
  }

  .more_load {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-radius: 0px 0px 20px 20px;
    // position: absolute;
    // bottom: 0;
    z-index: 9;
    color: #999999;
  }
}
</style>
